import React, {Fragment, useEffect, useState} from 'react';
import {selectLang} from "../../store/reducers/main/main";
import {useSelector} from "react-redux";
import {Translate} from "../../lang/lang";
import {FormProvider, useForm} from "react-hook-form";
import {editEmployeeAsync} from "../../store/reducers/employee/employeeReducer";
import toast from "react-hot-toast";
import IconButton from "../IconButton";
import {Button, Form, Modal} from "react-bootstrap";
import EmployeeForm from "./EmployeeForm";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEdit, faSpinner} from "@fortawesome/free-solid-svg-icons";

const EditEmployeeModal = ({employee, className}) => {

    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState(false);
    const lang = useSelector(selectLang);
    const t = Translate;

    const methods = useForm({
        defaultValues: {
            name: employee.name,
        }
    });

    useEffect(() => {
        methods.setValue('name', employee?.name)
    },[employee])

    const handleShow = () => setShow(true);
    const handleClose = () => {
        setShow(false)
        methods.reset()
    };

    const onSubmit = formData => {
        setLoading(true);

        editEmployeeAsync(employee.id, {name: formData.name})
            .then(() => {
                toast.success(t(lang, 'employee.edit_employee_modal.toast.success'));
                handleClose();
            })
            .catch(() => toast.error(t(lang, 'employee.edit_employee_modal.toast.error')))
            .finally(() => setLoading(false))
    };

    return (
        <Fragment>
            <IconButton icon={faEdit} className={className + ' bg-transparent'} variant={'phoenix-secondary'} onClick={handleShow}/>
            <Modal  show={show} onHide={handleClose}>
                <FormProvider {...methods}>
                    <Form onSubmit={methods.handleSubmit(onSubmit)}>
                        <Modal.Header closeButton={true}>
                            <Modal.Title>{t(lang, 'employee.edit_employee_modal.title')}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <EmployeeForm/>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button  variant="phoenix-secondary"
                                     className={'btn-davr'} onClick={handleClose}>{t(lang, 'main.common.back')}</Button>
                            <Button className={'btn-primary-davr'} variant={'primary'} type={'submit'} disabled={loading}>
                                {loading && <FontAwesomeIcon className="me-1" pulse={true} icon={faSpinner}/>}
                                {t(lang, 'main.common.edit')}
                            </Button>
                        </Modal.Footer>
                    </Form>
                </FormProvider>
            </Modal>
        </Fragment>
    );
};

export default EditEmployeeModal;
